import React, { useEffect, useState, createElement } from 'react';
import { TrendingUp, User, X, Lock, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { posthog } from '../lib/posthog';
declare global {
  interface Window {
    Tally?: {
      openPopup: (formId: string, options?: Record<string, any>) => void;
      closePopup: (formId: string) => void;
    };
  }
}
const EARLY_ACCESS_URL = 'https://register.gocaveo.com';
const USER_PASSWORD = 'learnpasswordcreationin2026!';
const INVESTOR_PASSWORD = 'ProtectYourFamily2026!';
function PasswordModal({
  isOpen,
  onClose,
  onSubmit,
  title,
  description,
  icon,
  error,
  password,
  onPasswordChange
}: {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  title: string;
  description: string;
  icon: React.ReactNode;
  error: string;
  password: string;
  onPasswordChange: (val: string) => void;
}) {
  if (!isOpen) return null;
  return <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '24px'
  }} onClick={onClose} data-id="element-1027">
      <div style={{
      backgroundColor: '#fff',
      borderRadius: '16px',
      padding: '32px',
      maxWidth: '384px',
      width: '100%',
      position: 'relative',
      boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)'
    }} onClick={e => e.stopPropagation()} data-id="element-1028">
        <button type="button" onClick={onClose} style={{
        position: 'absolute',
        top: '16px',
        right: '16px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#9ca3af',
        padding: '4px'
      }} data-id="element-1029">
          <X size={20} data-id="element-1030" />
        </button>

        <div style={{
        textAlign: 'center',
        marginBottom: '24px'
      }} data-id="element-1031">
          <div style={{
          width: '48px',
          height: '48px',
          backgroundColor: 'rgba(99,27,183,0.1)',
          borderRadius: '50%',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '16px'
        }} data-id="element-1032">
            {icon}
          </div>
          <h2 style={{
          fontSize: '20px',
          fontWeight: 600,
          color: '#111111',
          margin: '0 0 8px 0'
        }} data-id="element-1033">
            {title}
          </h2>
          <p style={{
          fontSize: '14px',
          color: '#6b7280',
          margin: 0
        }} data-id="element-1034">
            {description}
          </p>
        </div>

        <form onSubmit={onSubmit} data-id="element-1035">
          <input type="password" value={password} onChange={e => onPasswordChange(e.target.value)} placeholder="Enter password" autoFocus style={{
          width: '100%',
          padding: '12px 16px',
          border: '2px solid #e5e7eb',
          borderRadius: '8px',
          fontSize: '16px',
          outline: 'none',
          marginBottom: '12px',
          boxSizing: 'border-box'
        }} data-id="element-1036" />
          {error && <p style={{
          color: '#ef4444',
          fontSize: '14px',
          marginBottom: '12px',
          marginTop: 0
        }} data-id="element-1037">
              {error}
            </p>}
          <button type="submit" style={{
          width: '100%',
          backgroundColor: '#631bb7',
          color: '#fff',
          padding: '12px',
          borderRadius: '8px',
          fontWeight: 700,
          fontSize: '16px',
          border: 'none',
          cursor: 'pointer'
        }} data-id="element-1038">
            Log In
          </button>
        </form>
      </div>
    </div>;
}
export function ComingSoonPage() {
  const navigate = useNavigate();
  const [userModal, setUserModal] = useState(false);
  const [userPassword, setUserPassword] = useState('');
  const [userError, setUserError] = useState('');
  const [investorModal, setInvestorModal] = useState(false);
  const [investorPassword, setInvestorPassword] = useState('');
  const [investorError, setInvestorError] = useState('');
  // Load Tally embed script
  useEffect(() => {
    if (window.Tally) {
      return;
    }
    const existingScript = document.querySelector('script[src="https://tally.so/widgets/embed.js"]');
    if (existingScript) {
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://tally.so/widgets/embed.js';
    script.async = true;
    document.head.appendChild(script);
  }, []);
  // Listen for Tally form submissions and track them in PostHog
  useEffect(() => {
    const handleTallyMessage = (e: MessageEvent) => {
      const data = e.data;
      let parsed: any = data;
      if (typeof data === 'string') {
        try {
          parsed = JSON.parse(data);
        } catch {
          // Some Tally messages aren't JSON — bail out quietly
          return;
        }
      }
      if (parsed && typeof parsed === 'object' && parsed.event === 'Tally.FormSubmitted') {
        const formId = parsed.formId || parsed.payload?.formId;
        if (formId === '2E4rjD') {
          posthog.capture?.('waitlist_submitted', {
            source: 'coming_soon_page',
            form_id: formId,
            form_name: 'early_access_waitlist'
          });
        }
      }
    };
    window.addEventListener('message', handleTallyMessage);
    return () => window.removeEventListener('message', handleTallyMessage);
  }, []);
  const openEarlyAccessForm = () => {
    posthog.capture?.('waitlist_opened', {
      source: 'coming_soon_page',
      form_name: 'early_access_waitlist'
    });
    if (window.Tally) {
      window.Tally.openPopup('2E4rjD', {
        layout: 'modal',
        width: 700,
        autoClose: 5000
      });
    } else {
      // Retry after a short delay in case script is still loading
      setTimeout(() => {
        if (window.Tally) {
          window.Tally.openPopup('2E4rjD', {
            layout: 'modal',
            width: 700,
            autoClose: 5000
          });
        } else {
          window.open('https://tally.so/r/2E4rjD', '_blank');
        }
      }, 500);
    }
  };
  const handleUserSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (userPassword === USER_PASSWORD) {
      navigate('/home');
    } else {
      setUserError('Incorrect password. Please try again.');
      setUserPassword('');
    }
  };
  const handleInvestorSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (investorPassword === INVESTOR_PASSWORD) {
      navigate('/investor-portal');
    } else {
      setInvestorError('Incorrect password. Please try again.');
      setInvestorPassword('');
    }
  };
  const openInvestorModal = () => {
    setInvestorModal(true);
    setInvestorError('');
    setInvestorPassword('');
  };
  const openUserModal = () => {
    setUserModal(true);
    setUserError('');
    setUserPassword('');
  };
  const btnStyle = {
    boxShadow: '0 2px 6px 0 rgba(99,27,183,0.35)',
    width: '190px',
    backgroundColor: '#631bb7',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: 'Inter, sans-serif',
    padding: '8px 12px',
    whiteSpace: 'nowrap' as const
  };
  return <div className="w-full min-h-screen bg-white flex flex-col" data-id="element-1039">
      <div className="flex-grow flex items-center justify-center px-6 py-8 md:py-16" data-id="element-1040">
        <div className="max-w-2xl mx-auto text-center w-full" data-id="element-1041">
          {/* Logo */}
          <div className="mb-5 md:mb-10" data-id="element-1042">
            <img src="https://cdn.magicpatterns.com/uploads/cd519Db2szcZYHb21ayY7p/Digital_Logo.gif" alt="Caveo Logo" className="h-10 md:h-12 mx-auto" data-id="element-1043" />
          </div>

          {/* Coming Soon pill */}
          <button onClick={() => navigate('/home')} className="inline-flex items-center gap-1.5 border border-gray-200 text-gray-500 px-4 py-1.5 rounded-full text-sm font-medium mb-4 md:mb-8 hover:border-gray-300 transition-colors" style={{
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
        }} data-id="element-1044">
            <span data-id="element-1045">Coming Soon</span>
            <span className="text-gray-400" data-id="element-1046">›</span>
          </button>

          {/* Headline */}
          <h1 className="text-[2rem] md:text-[3.25rem] font-semibold text-[#111111] leading-[1.15] tracking-tight mb-4 md:mb-6" data-id="element-1047">
            <div className="text-[40px]" data-id="element-1048">Bringing Digital Safety</div>
            <div style={{
            color: '#631bb7'
          }} className="text-[40px]" data-id="element-1049">
              To Every Generation
            </div>
          </h1>

          {/* Subheadline */}
          <p className="text-base md:text-lg text-gray-500 leading-relaxed mb-5 md:mb-8 max-w-xl mx-auto px-5 font-[400]" data-id="element-1050">
            Protect your family from online scams, fraud and tech chaos while
            creating a safer, simpler digital life for the people you love.
          </p>

          {/* Social proof */}
          <div className="flex items-center justify-center gap-2 mb-5 md:mb-8 flex-wrap" data-id="element-1051">
            <div className="flex -space-x-1.5" data-id="element-1052">
              <img src="https://cdn.magicpatterns.com/uploads/6giMtsG68yxp89aaHTtkX6/Screenshot_2026-02-22_at_12.56.48_AM.png" alt="Member" className="w-6 h-6 rounded-full object-cover border-2 border-white" data-id="element-1053" />
              <img src="https://cdn.magicpatterns.com/uploads/iaPLUAtSe7j7WSJaQUSv1g/Screenshot_2026-02-22_at_12.56.42_AM.png" alt="Member" className="w-6 h-6 rounded-full object-cover border-2 border-white" data-id="element-1054" />
              <img src="https://cdn.magicpatterns.com/uploads/hCu7TZEUwwQyaw75WuLKPE/Screenshot_2026-02-22_at_12.56.35_AM.png" alt="Member" className="w-6 h-6 rounded-full object-cover border-2 border-white" data-id="element-1055" />
              <img src="https://cdn.magicpatterns.com/uploads/wJ71gACjNWRRTKd8byxEK6/Screenshot_2026-02-22_at_12.51.11_AM.png" alt="Member" className="w-6 h-6 rounded-full object-cover border-2 border-white" data-id="element-1056" />
              <img src="https://cdn.magicpatterns.com/uploads/f2JgivSXHBCeH7uM5GKP7x/Screenshot_2026-02-22_at_12.55.40_AM.png" alt="Member" className="w-6 h-6 rounded-full object-cover border-2 border-white" data-id="element-1057" />
            </div>
            <p className="text-xs text-gray-500" data-id="element-1058">
              Trusted by families who take digital security seriously.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col items-center gap-3" data-id="element-1059">
            <button type="button" onClick={openEarlyAccessForm} className="text-white rounded-lg font-semibold no-underline transition-all flex items-center justify-center gap-2" style={btnStyle} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#8b4fd4'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#631bb7'} data-id="element-1060">
              <ArrowRight size={15} data-id="element-1061" />
              Join Our Waitlist
            </button>

            <button type="button" onClick={openUserModal} className="text-white rounded-lg font-semibold transition-all flex items-center justify-center gap-2" style={btnStyle} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#8b4fd4'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#631bb7'} data-id="element-1062">
              <User size={15} data-id="element-1063" />
              User Log In
            </button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="py-6 text-center text-sm text-gray-400" data-id="element-1064">
        © 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.
      </div>

      <PasswordModal isOpen={userModal} onClose={() => setUserModal(false)} onSubmit={handleUserSubmit} title="User Access" description="Enter your password to continue." icon={<Lock size={22} color="#631bb7" data-id="element-1066" />} error={userError} password={userPassword} onPasswordChange={val => {
      setUserPassword(val);
      setUserError('');
    }} data-id="element-1065" />

      <PasswordModal isOpen={investorModal} onClose={() => setInvestorModal(false)} onSubmit={handleInvestorSubmit} title="Investor Access" description="Enter your password to view the investor deck." icon={<TrendingUp size={22} color="#631bb7" data-id="element-1068" />} error={investorError} password={investorPassword} onPasswordChange={val => {
      setInvestorPassword(val);
      setInvestorError('');
    }} data-id="element-1067" />
    </div>;
}